import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DruhPozadavku = {
	name: NAME,
	apiProvider,
	router,
};
